import _ from "lodash";
import { createSelector } from "reselect";

import UrlPrefixes from "../../constants/urlPrefixes";

const getAttachmentIds = state => state.data.attachments.allIds;
const getAttachmentsById = state => state.data.attachments.byId;

const isAttachmentEmbedded = a => a.path.startsWith(UrlPrefixes.ATTACHMENT_PREFIX);
const doesItemHaveAttachment = (item, id) => item.attachments.includes(id) || item.image === id;

const isAttachmentInUseByAnotherItem = (state, attachmentId, excludeItemIds) =>
  Boolean(
    state.data.items.byId.find(
      item => !_.includes(excludeItemIds, item.id) && doesItemHaveAttachment(item, attachmentId)
    )
  );

const getEmbeddedAttachments = createSelector(
  // inputs
  getAttachmentsById,
  // calculate based on inputs
  attachmentsById => {
    return attachmentsById
      .filter(isAttachmentEmbedded)
      .toList()
      .map(a => a.id);
  }
);

export default {
  getAttachmentIds,
  getAttachmentsById,
  getEmbeddedAttachments,
  isAttachmentInUseByAnotherItem,
  isAttachmentEmbedded
};
